export default {
  setLoggedIn(state, status) {
    state.isLoggedIn = status;
  }
};